import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { CreatureTrait } from '../../types';
import { PopoverItem } from '../../hooks/useItemPopover';

interface MemberTraitsProps {
  traits: CreatureTrait[];
  onItemClick: (event: React.MouseEvent<HTMLElement>, item: PopoverItem) => void;
}

export const MemberTraits: React.FC<MemberTraitsProps> = ({ traits, onItemClick }) => {
  if (traits.length === 0) return null;

  return (
    <Box sx={{ mb: 2, display: 'flex', gap: 3, alignItems: 'flex-start' }}>
      <Box sx={{ flexShrink: 0 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Traits</Typography>
        <Stack direction="row" spacing={1} alignItems="flex-start">
          {traits.map((trait) => (
            <Chip
              key={trait.id}
              size="small"
              label={trait.name}
              onClick={(e) => onItemClick(e, { id: trait.id, name: trait.name, description: trait.description ?? '', specialTags: [] })}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};
